import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MessageSquare, Send } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';

const TauntSelectionModal = ({ opponentName, onSend, onCancel }) => {
    const { t } = useTranslation();
    const [taunt, setTaunt] = useState('');

    const preSetTaunts = [
        t('showdown.tauntModal.preset1'),
        t('showdown.tauntModal.preset2'),
        t('showdown.tauntModal.preset3'),
        t('showdown.tauntModal.preset4'),
    ];

    const handleSend = () => {
        onSend(taunt || t('showdown.tauntModal.defaultChallenge', { opponentName }));
    };

    const backdropVariants = {
        hidden: { opacity: 0 },
        visible: { opacity: 1 },
    };

    const modalVariants = {
        hidden: { opacity: 0, scale: 0.9 },
        visible: { opacity: 1, scale: 1, transition: { type: 'spring', stiffness: 300, damping: 30 } },
        exit: { opacity: 0, scale: 0.9 },
    };

    return (
        <AnimatePresence>
            <motion.div
                className="fixed inset-0 bg-black/70 flex items-center justify-center z-50"
                variants={backdropVariants}
                initial="hidden"
                animate="visible"
                exit="hidden"
                onClick={onCancel}
            >
                <motion.div
                    className="bg-gray-800 p-8 rounded-lg shadow-2xl text-white max-w-lg w-full"
                    variants={modalVariants}
                    onClick={e => e.stopPropagation()}
                >
                    <h2 className="text-3xl font-bold mb-4">{t('showdown.tauntModal.title', { opponentName })}</h2>
                    <p className="text-gray-400 mb-6">{t('showdown.tauntModal.description')}</p>
                    
                    <textarea
                        value={taunt}
                        onChange={(e) => setTaunt(e.target.value)}
                        placeholder={t('showdown.tauntModal.placeholder')}
                        className="w-full bg-gray-900 text-white p-3 rounded-lg h-24 mb-4"
                        maxLength={100}
                    />

                    <div className="grid grid-cols-2 gap-2 mb-6">
                        {preSetTaunts.map((t, i) => (
                            <button key={i} onClick={() => setTaunt(t)} className="p-2 bg-gray-700 hover:bg-gray-600 rounded-lg text-sm btn-interactive">
                                {t}
                            </button>
                        ))}
                    </div>

                    <div className="flex justify-end gap-4">
                        <button onClick={onCancel} className="px-6 py-2 bg-gray-600 hover:bg-gray-500 rounded-lg font-bold btn-interactive">{t('common.cancel')}</button>
                        <button onClick={handleSend} className="px-6 py-2 bg-indigo-600 hover:bg-indigo-500 rounded-lg font-bold flex items-center gap-2 btn-interactive">
                            <Send size={16} /> {t('showdown.tauntModal.sendChallenge')}
                        </button>
                    </div>
                </motion.div>
            </motion.div>
        </AnimatePresence>
    );
};

export default TauntSelectionModal;
